import React from 'react';
import { object, string, arrayOf, number, func, bool } from 'prop-types';
import TileContainer from 'sections/tile-container/TileContainer';
import NoItems from './NoItems';
import Resources from '../resources/';

export default function ListingItemsSection({
    resultTitle, listingItems, resources, tileContainerColumnClass, tileContainerTilesWrap, tileType,
    resetFilters, showMoreItems, showingItems, totalItems, showMoreButtonLabel, showMoreButtonType, showMoreOnScroll
}) {
    let itemsResourcesWrapperClass = 'items-resources-wrapper';

    if (resources.length >= 1) {
        itemsResourcesWrapperClass += ' has-resources';
    }
    return (
        <div className="listing-items">
            <div className="listing-items-container">
                <div className={itemsResourcesWrapperClass}>
                    {resultTitle !== '' ? <h2>{resultTitle}</h2> : false}
                    <div className="items-wrapper">
                        <NoItems
                            items={listingItems}
                            resetFilters={resetFilters}
                        />

                        <TileContainer
                            items={listingItems}
                            columnClass={tileContainerColumnClass}
                            tileWrap={tileContainerTilesWrap}
                            tileType={tileType}
                        />

                        {totalItems > showingItems ?
                            <div
                                className={`${showMoreOnScroll ? 'js-react-load-more-on-scroll' : ''} btn-more ${showMoreButtonType ? 'btn-skin-1' : 'btn-text'}`}
                                onClick={showMoreItems}
                                onKeyPress={e => { if (e.key === 'Enter') { this.props.showMoreItems.call(this, null); } }}
                                role="button"
                                tabIndex="0"
                            >
                                {showMoreButtonLabel} &darr;
                            </div> : false
                        }
                    </div>
                    <Resources resources={resources} />
                </div>
            </div>
        </div>
    );
}

ListingItemsSection.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    resultTitle: string,
    listingItems: arrayOf(object).isRequired,
    tileContainerColumnClass: string.isRequired,
    tileContainerTilesWrap: string.isRequired,
    tileType: string.isRequired,
    resources: arrayOf(object).isRequired,
    resetFilters: func.isRequired,
    showMoreItems: func.isRequired,
    showingItems: number.isRequired,
    totalItems: number.isRequired,
    showMoreButtonLabel: string.isRequired,
    showMoreButtonType: bool.isRequired,
    showMoreOnScroll: bool.isRequired
    /* eslint-enable react/no-typos */
};

ListingItemsSection.defaultProps = { resultTitle: '' };
